import { Injectable } from '@angular/core';

/**
 * Tracks every leaf Uri registered in the sidebar menu so that
 * MenuListItemComponent can tell whether a route prefix match is actually
 * the most specific match, instead of highlighting every menu item whose
 * Uri happens to be a text prefix of another item's Uri
 * (e.g. "invoice" vs "invoice/payments-list").
 */
@Injectable({ providedIn: 'root' })
export class MenuActiveService {
  private uris: string[] = [];

  setUris(uris: string[]): void {
    this.uris = uris;
  }

  /**
   * True when `uri` is the longest registered menu Uri that matches
   * `currentUrl` (exact match, or currentUrl starting with `uri/`).
   */
  isLongestMatch(uri: string, currentUrl: string): boolean {
    const candidates = this.uris.filter(u => currentUrl === u || currentUrl.startsWith(`${u}/`));

    if (!candidates.length) return false;

    const longest = candidates.reduce((a, b) => (b.length > a.length ? b : a));
    return longest === uri;
  }
}
